export const getDatesGroupedByWeek = (dates: Date[]): Array<Array<Date>> => {
  let curIndex = 0;
  const retVal: Array<Array<Date>> = [];
  let curWeek: Array<Date> = [];
  while (curIndex < dates.length) {
    if (curIndex > 0 && curIndex % 7 === 0) {
      retVal.push(curWeek);
      curWeek = [];
    }
    curWeek.push(dates[curIndex++]);
  }
  if (curWeek.length > 0) {
    retVal.push(curWeek);
  }
  return retVal;
};
